import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserState {
  user: any | null;      // L'utilisateur peut être un objet ou null
  token: string | null;   // Le token peut être une chaîne ou null
  loading: boolean;
  error: string | null;
}

// Fonction pour récupérer l'utilisateur depuis localStorage
const getInitialUser = (): any | null => {
  try {
    const storedUser = localStorage.getItem('user');
    if (!storedUser || storedUser === 'undefined' || storedUser === 'null') {
      return null;
    }
    return JSON.parse(storedUser);
  } catch {
    return null;
  }
};

// Fonction pour récupérer le token depuis localStorage
const getInitialToken = (): string | null => {
  const token = localStorage.getItem('token');
  return token && token !== 'undefined' ? token : null;
};

const initialState: UserState = {
  user: getInitialUser(),
  token: getInitialToken(),
  loading: false,
  error: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    // Définir l'utilisateur et le token
    setUser: (state, action: PayloadAction<{ user: any; token: string }>) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      localStorage.setItem('user', JSON.stringify(action.payload.user));
      localStorage.setItem('token', action.payload.token);
    },
    // Mettre à jour uniquement l'utilisateur
    updateUser: (state, action: PayloadAction<{ user: any }>) => {
      state.user = action.payload.user;
      localStorage.setItem('user', JSON.stringify(action.payload.user));
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    // Déconnexion
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.loading = false;
      state.error = null;
      localStorage.removeItem('user');
      localStorage.removeItem('token');
    },
  },
});

// Selector pour récupérer le user uniquement s'il y a un token valide
export const selectConnectedUser = (state: any) => {
  const u = state.user.user;
  const t = state.user.token;
  return u && t ? u : null;
};

export const { setUser, updateUser, setLoading, setError, logout } = userSlice.actions;
export default userSlice.reducer;
